import productValidations from './Product.js';
import dateValidations from './EventDate.js';

export default function(ngModule) {
    ngModule.factory('AccessProduct', function(BaseClass, $q, $http, Product, EventDate, EventLocation, $analytics) {
        function AccessProduct(attributes) {
            this.product = Product.new({ type: 'normal', vat_percentage: 21 });
            this.eventDate = EventDate.new();
            _.assign(this, attributes);
        }
        AccessProduct.modelName = 'AccessProduct';

        AccessProduct.initFromProduct = function(product) {
            return product.$queryEventDate().then(dates => {
                if(!dates.length)
                    return $q.reject(new Error('No dates found for product'));
                else if(dates.length > 1)
                    return $q.reject(new Error('Multiple dates found for product'));

                let accessProduct = new AccessProduct({
                    product: product,
                    eventDate: dates[0]
                });

                accessProduct.meta_data = product.meta_data;

                accessProduct.validate();

                return accessProduct;
            });
        };

        AccessProduct.primaryKey = 'guid';

        Object.defineProperties(AccessProduct.prototype, {
            $save: {
                value: function() {
                    let isNew = !this.product.guid;
                    let that = this;
                    return this.eventDate.$save()
                        .then(() => {
                            that.product.description = that.eventDate.guid;
                            return that.product.$save();
                        }).then(() => {
                            if(isNew) {
                                $analytics.eventTrack('created-event-date', {
                                    name: that.eventDate.name,
                                    start_date: parseInt(moment(that.eventDate.start).format('X'), 10),
                                    end_date: parseInt(moment(that.eventDate.end).format('X'), 10),
                                    label: that.product.name,
                                    value: [that.eventDate.start, that.eventDate.end].join(' - ')
                                });
                                return that.product.$attachEventDate(that.eventDate).then(() => that);
                            }
                            return that;
                        });
                }
            },
            $delete: {
                value: function() {
                    return $q.all([ this.product.$delete(), this.eventDate.$delete() ]);
                }
            },
            validate: {
                value: function(fields) {
                    return this.product.validate(fields) || this.eventDate.validate(fields);
                }
            },
            $invalid: {
                get: function() {
                    return this.product.$invalid ||
                        !this.eventDate.validate('start') ||
                        !this.eventDate.validate('end');
                    // Don't validate location_id, because the wizard might create a new location and
                    // set location_id right before saving AccessProduct
                },
                set: function(v) { return v; }
            },
            $errors: {
                get: function() {
                    return _.defaults(
                        {
                            clear: () => this.product.$errors.clear() && this.ticket.$errors.clear()
                        },
                        this.product.$errors,
                        this.eventDate.$errors
                    );
                },
                set: function(v) { return v; }
            },
            $detachMetaData: {
                get: function() { return this.product.$detachMetaData.bind(this.product); }
            },
            $attachMetaData: {
                get: function() { return this.product.$attachMetaData.bind(this.product); }
            },
            $queryMetaData: {
                get: function() { return this.product.$queryMetaData.bind(this.product); }
            },
            belongsToMany: {
                get: function() { return this.product.belongsToMany; }
            },
            broadcastAPIMessage: {
                get: function() { return this.product.broadcastAPIMessage.bind(this.product); }
            }
        });

        Object.defineProperties(AccessProduct.prototype, {
            guid: {
                get: function() { return this.product.guid; },
                set: function(guid) { return this.product.guid = guid; },
                enumerable: true
            },
            name: {
                get: function() { return this.product.name; },
                set: function(name) {
                    this.product.name = name;
                    return this.eventDate.name = name;
                },
                enumerable: true
            },
            description: {
                get: function() { return this.product.description; },
                set: function(description) {
                    return this.product.description = description;
                },
                enumerable: true
            },
            type: {
                get: function() { return this.product.type; },
                set: function(type) {
                    return this.product.type = type;
                },
                enumerable: true
            },
            class: {
                get: function() { return this.product.class; },
                set: function(clss) {
                    return this.product.class = clss;
                },
                enumerable: true
            },
            price: {
                get: function() { return this.product.price; },
                set: function(price) {
                    return this.product.price = price;
                },
                enumerable: true
            },
            vat_percentage: {
                get: function() { return this.product.vat_percentage; },
                set: function(vatPercentage) {
                    return this.product.vat_percentage = vatPercentage;
                },
                enumerable: true
            },
            location: {
                get: function() {
                    return EventLocation.cached[this.eventDate.location_id];
                },
                set: function(location) {
                    this.eventDate.location_id = _.get(location,'guid');
                    return location;
                }
            },
            location_id: {
                get: function() { return this.eventDate.location_id; },
                set: function(locationId) {
                    return this.eventDate.location_id = locationId;
                },
                enumerable: true
            },
            event_id: {
                get: function() { return this.eventDate.event_id; },
                set: function(eventId) {
                    return this.eventDate.event_id = eventId;
                },
                enumerable: true
            },
            capacity: {
                get: function() { return this.eventDate.capacity; },
                set: function(capacity) {
                    return this.eventDate.capacity = capacity;
                },
                enumerable: true
            },
            start: {
                get: function() { return this.eventDate.start; },
                set: function(start) {
                    return this.eventDate.start = start;
                },
                enumerable: true
            },
            end: {
                get: function() { return this.eventDate.end; },
                set: function(end) {
                    return this.eventDate.end = end;
                },
                enumerable: true
            }
        });

        BaseClass.apply(AccessProduct);
        return AccessProduct;
    });
}
